<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    @click:outside="close"
    class="overflow-hidden"
  >
    <pulse-schedule
      simple
      title="Culture tracking settings"
      v-on:save="close"
      v-on:close="close"
      v-on:success="close"
    ></pulse-schedule>
  </v-dialog>
</template>

<script>
import PulseSchedule from "@/components/pulse/PulseSchedule";
export default {
  name: "SimplePulseSettingsDialog",
  components: { PulseSchedule },
  props: {},
  data: () => ({
    dialog: false
  }),
  created() {},
  methods: {
    showDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("close");
    }
  }
};
</script>
